/* eslint-disable no-undef */

import React from 'react'
import { Box, Paper, makeStyles } from '@material-ui/core'
import parse from 'html-react-parser'

const useStyles = makeStyles(theme => ({
    root: {
        fontFamily: '"Plus Jakarta Sans", sans-serif'
    },
    imageWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
        height: 90
    },
    image: {
        maxWidth: '100%',
        maxHeight: '70px',
        opacity: 0.9,
        filter: 'grayscale(20%)',
        transition: 'all 0.2s ease',
        '&:hover': {
            opacity: 1,
            filter: 'grayscale(0%)'
        }
    },
    smallImageWrapper: {
        float: 'left',
        marginRight: theme.spacing(1.5),
        width: 40,
        height: 40,
        borderRadius: '50%',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #e6f2ed 0%, #d4e8df 100%)',
        flexShrink: 0
    },
    smallImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '50%'
    },
    title: {
        fontWeight: 600,
        fontSize: '0.95rem',
        lineHeight: '1.35rem',
        color: '#1a2e23',
        fontFamily: '"Plus Jakarta Sans", sans-serif'
    }
}))

function ExtraElement({ imageSrc, smallImageSrc, title, description }) {
    const classes = useStyles()

    return (
        <Box className={classes.wrapper + ' ' + classes.paper} elevation={1}>
            {imageSrc && (
                <Box className={classes.imageWrapper}>
                    <img src={imageSrc} className={classes.image} />
                </Box>
            )}
            {title && (
                <Box mb={0.5} className={classes.title}>
                    {parse(title)}
                </Box>
            )}
            {description && (
                <Box>
                    {smallImageSrc && (
                        <Box className={classes.smallImageWrapper}>
                            <img src={smallImageSrc} className={classes.smallImage} />
                        </Box>
                    )}
                    {parse(description)}
                </Box>
            )}
        </Box>
    )
}

export default ExtraElement
